import org.khronos.webgl.WebGLRenderingContext as GL
import org.khronos.webgl.Float32Array
import org.khronos.webgl.Uint16Array
import kotlin.math.*

class DonutGeometry(val gl : WebGL2RenderingContext) {
var vertices = 360
var inner_vert_buffer_points = arrayOf<Float>()
var outer_vert_buffer_points = arrayOf<Float>()
var sum_buffer_points = arrayOf<Float>()
var tri_indeces = arrayOf<Short>()
var thick = 2

  val vertexBuffer = gl.createBuffer()
  init{
    var theta = 0.0
    var vertices = vertices
    // outer_vert_buffer_points += arrayOf<Float>(0.0f, 
    //                                     0.0f,
    //                                     0.0f)

    while (theta <= 2*PI) {  
        //fills out vertex buffer for outer points along circle
        outer_vert_buffer_points += arrayOf<Float>((thick * kotlin.math.cos(theta)).toFloat(), 
                                             (thick * kotlin.math.sin(theta)).toFloat(),
                                             0.0f)

        inner_vert_buffer_points += arrayOf<Float>(kotlin.math.cos(theta).toFloat(), 
                                             kotlin.math.sin(theta).toFloat(),
                                             0.0f)
        theta += 2*PI / vertices
    }

    sum_buffer_points += inner_vert_buffer_points
    sum_buffer_points += outer_vert_buffer_points

    gl.bindBuffer(GL.ARRAY_BUFFER, vertexBuffer) //#ARRAY_BUFFER# OpenGL dictionary:; array buffer means vertex buffer #bind# OpenGL phraseology:; Binding means: select as current. Further operations on the same target affect the bound resource.
    gl.bufferData(GL.ARRAY_BUFFER,
      Float32Array(sum_buffer_points),
      GL.STATIC_DRAW)
  }

  val vertexColorBuffer = gl.createBuffer() //bh copy
  init{
    gl.bindBuffer(GL.ARRAY_BUFFER, vertexColorBuffer) //#ARRAY_BUFFER# OpenGL dictionary:; array buffer means vertex buffer #bind# OpenGL phraseology:; Binding means: select as current. Further operations on the same target affect the bound resource.
    gl.bufferData(GL.ARRAY_BUFFER,
      Float32Array(sum_buffer_points),
      GL.STATIC_DRAW)
  }

  val indexBuffer = gl.createBuffer()
  init{
    // var tri_indeces = arrayOf<Short>(0.toShort(), 0.toShort(), 0.toShort())

    for (n in 0..(2 * vertices)){
        tri_indeces += arrayOf<Short>(n.toShort(), //specifies which verticies to draw the triangles between
                                  (n + vertices).toShort(), 
                                  (n+1).toShort())

        tri_indeces += arrayOf<Short>((n+1).toShort(), //specifies which verticies to draw the triangles between
                                  (vertices + n).toShort(), 
                                  (vertices + n + 1).toShort())}

        tri_indeces += arrayOf<Short>(0.toShort(), //last slice
                                  (vertices).toShort(), 
                                  (vertices + 1).toShort())
    
    gl.bindBuffer(GL.ELEMENT_ARRAY_BUFFER, indexBuffer) //#ELEMENT_ARRAY_BUFFER# OpenGL dictionary:; element array buffer: index buffer
    gl.bufferData(GL.ELEMENT_ARRAY_BUFFER,
      Uint16Array(tri_indeces), //
      GL.STATIC_DRAW)
  }

  val inputLayout = gl.createVertexArray() //#VertexArray# OpenGL dictionary:; vertex array object (VAO) is input layout
  init{
    gl.bindVertexArray(inputLayout)

    gl.bindBuffer(GL.ARRAY_BUFFER, vertexBuffer)
    gl.enableVertexAttribArray(0)
    gl.vertexAttribPointer(0, //#0# this explains how attribute 0 can be found in the vertex buffer
      3, GL.FLOAT, //< three pieces of float
      false, //< do not normalize (make unit length)
      0, //< tightly packed
      0 //< data starts at array start
    )

    gl.bindBuffer(GL.ARRAY_BUFFER, vertexColorBuffer) //this specifies attribute 1 which is color, and should be taken from this...
    gl.enableVertexAttribArray(1)
    gl.vertexAttribPointer(1, //#0# this explains how attribute 1 can be found in the vertex buffer
      3, GL.FLOAT, //< three pieces of float
      false, //< do not normalize (make unit length)
      0, //< tightly packed
      0 //< data starts at array start
    )

    gl.bindVertexArray(null)
  }

  fun draw() {

    console.log(sum_buffer_points, tri_indeces)

    gl.bindVertexArray(inputLayout)
    gl.bindBuffer(GL.ELEMENT_ARRAY_BUFFER, indexBuffer)  

    gl.drawElements(GL.TRIANGLES, 2 * 3 * (vertices + 1) , GL.UNSIGNED_SHORT, 0) //#3# pipeline is all set up, draw three indices worth of geometry
  }}
